import { Component, Input } from '@angular/core';

@Component({
  selector: 'gw-law-details-tab-content',
  templateUrl: './law-details-tab-content.component.html'
})
export class LawDetailsTabContentComponent {
  @Input() greyHeader = false;
}
